import React from "react";
import { Modal, Text, Stack, AspectRatio } from "@mantine/core";

// Detecta si la url es un embed de YouTube/Vimeo o un archivo de video directo
const getEmbedUrl = (url) => {
   if (!url) return null;
   const yt = url.match(
      /(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]+)/
   );
   if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
   const vimeo = url.match(/vimeo\.com\/(\d+)/);
   if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}`;
   return null;
};

const VideoPlayer = ({ url }) => {
   const embed = getEmbedUrl(url);
   if (embed) {
      return (
         <AspectRatio ratio={16 / 9}>
            <iframe
               src={embed}
               title="video"
               style={{ border: 0, borderRadius: 8 }}
               allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
               allowFullScreen
            />
         </AspectRatio>
      );
   }
   // archivo directo (.mp4, .webm, etc.)
   return (
      <AspectRatio ratio={16 / 9}>
         <video src={url} controls style={{ borderRadius: 8, width: "100%" }} />
      </AspectRatio>
   );
};

const HelpCardModal = ({ opened, onClose, card }) => {
   if (!card) return null;

   return (
      <Modal
         opened={opened}
         onClose={onClose}
         title={card.title}
         size="lg"
         centered
         styles={{
            title: {
               fontSize:"var(--fs-body)",
               fontFamily:"var(--font-primary)",
               color:"#005163",
               fontWeight:900,
            }
         }}
         radius="md"
      >
         <Stack gap="md">

            {card.description && (
               <Text size="sm" c="dimmed">
                  {card.description}
               </Text>
            )}

            {card.video_url && <VideoPlayer url={card.video_url} />}
         </Stack>
      </Modal>
   );
};

export default HelpCardModal;